import { useState, useEffect } from 'react';
import { Diamond } from 'lucide-react';
import { META, ROUTES } from './data';

// Lumen & Stone Header — black-glass strip on velvet bg, champagne accent.
// Distinctive: brand mark sits on left with a small diamond glyph; nav RIGHT-justified.
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  return (
    <header className={`fixed top-0 inset-x-0 z-40 transition-all duration-700 ${scrolled ? 'bg-[#0B0A0E]/85 backdrop-blur-md border-b border-[#C9B68B]/10' : ''}`}>
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 h-20 flex items-center justify-between gap-6">
        <button onClick={() => setPage('home')} className="flex items-center gap-3 text-[#C9B68B]" data-testid="jewel-logo">
          <Diamond className="w-4 h-4 rotate-45" strokeWidth={1.2} fill="currentColor" />
          <span className="font-serif text-2xl text-white" dangerouslySetInnerHTML={{ __html: META.brand }} />
        </button>
        <nav className="hidden lg:flex items-center gap-10">
          {ROUTES.map(r => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`jewel-nav-${r.id}`}
              className={`font-mono text-[10px] tracking-[0.32em] uppercase transition-colors ${page === r.id ? 'text-[#C9B68B]' : 'text-white/55 hover:text-white'}`}>
              {r.label}
            </button>
          ))}
        </nav>
        <button onClick={() => setPage('commission')} className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9B68B] border border-[#C9B68B]/40 px-4 py-2 hover:bg-[#C9B68B] hover:text-[#0B0A0E] transition-colors" data-testid="jewel-cta-commission">
          Commission
        </button>
      </div>
    </header>
  );
}
